// ADDED
import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import LeaveIncentiveModule from "../../components/modules/LeaveIncentive/LeaveIncentiveModule";

const LeaveIncentivePage = ({ user, isHideSideMenu }) => {
  // Initialize the hook with user context for audit trails
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg overflow-hidden">
            <LeaveIncentiveModule
              user={user}
              showGeneralMessage={showGeneralMessage}
            />
          </div>
        </div>
      </div>

      {/* Global messaging for success/error alerts */}
      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />

    </>
  );
};

export default LeaveIncentivePage;